export type DateInput = Date | string | number;

export const MOSCOW_TIME_ZONE = "Europe/Moscow";

const dateFormatter = new Intl.DateTimeFormat("ru-RU", {
  timeZone: MOSCOW_TIME_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

const dateTimeFormatter = new Intl.DateTimeFormat("ru-RU", {
  timeZone: MOSCOW_TIME_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
});

function toValidDate(value: DateInput): Date | null {
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

function readPart(parts: Intl.DateTimeFormatPart[], type: string): string {
  return parts.find((part) => part.type === type)?.value ?? "";
}

function formatParts(value: DateInput, formatter: Intl.DateTimeFormat, includeTime: boolean): string {
  const date = toValidDate(value);
  if (!date) return "—";
  const parts = formatter.formatToParts(date);
  const result = `${readPart(parts, "day")}.${readPart(parts, "month")}.${readPart(parts, "year")}`;
  return includeTime ? `${result}, ${readPart(parts, "hour")}:${readPart(parts, "minute")}` : result;
}

export function formatMoscowDate(value: DateInput): string {
  return formatParts(value, dateFormatter, false);
}

export function formatMoscowDateTime(value: DateInput): string {
  return formatParts(value, dateTimeFormatter, true);
}

export function moscowIsoDate(value: DateInput = new Date()): string {
  const date = toValidDate(value);
  if (!date) return "";
  const parts = dateFormatter.formatToParts(date);
  return `${readPart(parts, "year")}-${readPart(parts, "month")}-${readPart(parts, "day")}`;
}

export function moscowDateTimeInput(value: DateInput = new Date()): string {
  const date = toValidDate(value);
  if (!date) return "";
  const parts = dateTimeFormatter.formatToParts(date);
  return `${readPart(parts, "year")}-${readPart(parts, "month")}-${readPart(parts, "day")}T${readPart(parts, "hour")}:${readPart(parts, "minute")}`;
}

export function moscowDateTimeInputAt(
  hour: number,
  minute = 0,
  value: DateInput = new Date(),
): string {
  if (!Number.isInteger(hour) || hour < 0 || hour > 23 || !Number.isInteger(minute) || minute < 0 || minute > 59) {
    throw new Error("Некорректное время документа");
  }
  const day = moscowIsoDate(value);
  return day ? `${day}T${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}` : "";
}

export function moscowDateTimeInputToIso(value: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(value);
  if (!match) throw new Error("Укажите дату и время документа");
  return `${match[1]}-${match[2]}-${match[3]}T${match[4]}:${match[5]}:00+03:00`;
}
